import { Text } from '@mantine/core';
import { useMemo } from 'react';
import { nextCronRun } from '../helpers/cronValidator';

// "Next sync: <date>" under a cron schedule field, or nothing at all when the
// schedule has no next occurrence.
//
// The four settings tabs that show this each computed nextCronRun inline behind
// an `isInvalidCronExpression` gate. That gate does not cover every case
// nextCronRun returns null for: an expression that parses but never fires
// (`0 0 31 2,4,6 *` -- the 31st of February, April and June) is "valid", so the
// label rendered a bare "Next sync:" with no date after it. Deciding from the
// value rather than from a separate validity check is what makes that
// impossible, and it keeps the four displays from drifting apart again -- two
// were already a raw <small> and two a Mantine <Text>.
const NextSyncLabel = ({ schedule }) => {
  // Memoised on the expression: giving up on one that never fires costs ~25ms
  // (see cronValidator.jsx), and these tabs re-render for unrelated reasons.
  const nextRun = useMemo(() => nextCronRun(schedule), [schedule]);

  if (!nextRun) {
    return null;
  }

  return (
    <Text size="xs" mt="xs">
      Next sync: {nextRun}
    </Text>
  );
};

export default NextSyncLabel;
